import React, { Component } from "react"
import _ from "lodash"
import { connect } from "react-redux"

export default function RequireSelectedPet(ComposedComponent) {
  class Authentication extends Component {
    UNSAFE_componentWillMount() {
      if (_.isEmpty(this.props.pet)) {
        this.props.history.push("/userhome")
      }
    }

    UNSAFE_componentWillUpdate(nextProps) {
      if (_.isEmpty(nextProps.pet)) {
        this.props.history.push("/userhome")
      }
    }

    render() {
      return <ComposedComponent {...this.props} />
    }
  }

  const mapStateToProps = (state) => {
    return {
      pet: state.reducers.pets.selectedPet,
    }
  }
  return connect(mapStateToProps)(Authentication)
}
